import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/user.service';
import { LoaderService } from '../../shared/services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { NavigationService } from '../../shared/services/navigation.service';
import { finalize } from 'rxjs/operators';
import { ModalService } from '../../shared/services/modal.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {

  loadPage = (page: number, pageSize: number) => this.userService.searchAll(page, pageSize);

  constructor(
    private authService: AuthenticationService,
    private userService: UserService,
    private navigation: NavigationService,
    private toastr: ToastrService,
    private loader: LoaderService
  ) {
    this.loader.startLoad(false);
  }

  ngOnInit() {
  }

  goToCreateUser(): void {
    this.navigation
      .users()
      .create()
      .go();
  }

  goToEditUser(id: string): void {
    this.navigation
      .users()
      .edit(id)
      .go();
  }

}
